import { Component, OnInit } from '@angular/core';
import { Router } from '../../../../node_modules/@angular/router';

@Component({
selector: 'app-site-footer',
templateUrl: './site-footer.component.html',
styleUrls: ['./site-footer.component.css']
})
export class SiteFooterComponent implements OnInit {
    //feedbackType="Comment";

constructor(private router: Router,) { }

ngOnInit() {
}

currentYear = new Date().getFullYear();

isToken(){
var token=sessionStorage.getItem('token');

if(!token) return null;

return true;
}
// feedbackDetailsUrl( feedbackType: String) {
//     this.router.navigate(['/comment', feedbackType]);
//     }
    
 feedbackUrl(feedbackType) {
    this.router.navigate(['/contactUs',feedbackType ]);
     /*Temporary Solutions For Refresh*/ 
    //  this.router.navigate(['/contactUs',feedbackType]).then(()=> this.router.navigate(['/sidenav/testing']))
    
    }

    termsConditionUrl() {
        this.router.navigate(['/termsCondition']);
    }

    privacyPolicyUrl() {
        this.router.navigate(['/privacyPolicy']);
    }

    scrollToTop(): void {
        const scrollDuration = 1000; // increase for slower scroll (ms)
        const scrollStep = -window.scrollY / (scrollDuration / 15);

        const scrollInterval = setInterval(() => {
            if (window.scrollY > 0) {
            window.scrollBy(0, scrollStep);
            } else {
            clearInterval(scrollInterval);
            }
        }, 15);
    }
}

